<section class="section">
  <div class="dashHeader">
    <div class="driver"></div>
  </div>
  <div class="tablediv" style="margin: 16px">
    <div class="OrdersList">
      <div class="head">
        <div
          style="
            font-family: 'Inter';
            font-style: normal;
            font-weight: 700;
            font-size: 15px;
            color: #000000;
          "
          >Rental Requests</div
        >
        <div class="filters">
          <div class="filters-left">
            <div>
              <label>From Date</label>
              <input type="date" class="form-control" (input)="onFilterSelect($event)" name="fromDate" [value]="queryParams?.fromDate">
            </div>
            <div>
              <label>To Date</label>
              <input type="date" class="form-control" (input)="onFilterSelect($event)" name="toDate" [value]="queryParams?.toDate">
            </div>
          </div>
          <div class="filters-right">
            <app-refresh-button></app-refresh-button>
            <input type="search" class="form-control" placeholder="Search" (input)="onFilterSelect($event)" name="search" [value]="queryParams?.search ?? null">
          </div>
        </div>
      </div>
      <div>
        <div class="Orderstabel">
          <table class="tabledriver">
            <thead
              style="
                white-space: nowrap;
                font: normal normal 600 14px/17px Inter;
                height: 46px;
                letter-spacing: 0px;
                color: #24272a;
                opacity: 1;
              "
            >
              <tr class="tabelhead">
                <th scope="col">Consumer Name</th>
                <th scope="col">Consumer Phone No</th>
                <th scope="col">Consumer Email</th>
                  <th scope="col">Vehicle Name</th>
                  <th scope="col">Place</th>
                  <th scope="col">From Date</th>
                  <th scope="col">To Date</th>
                  <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody style="text-align: center; white-space: nowrap">
              <tr
                style="
                  text-align: left;
                  text-align: left;
                  font: normal normal normal 12px/15px Inter;
                  letter-spacing: 0px;
                  color: #24272a;
                "
                *ngFor="
                  let req of vehicleRequests
                    | paginate
                      : {
                          itemsPerPage: recordPerPage,
                          currentPage: page,
                          totalItems: totalRecords
                        };
                  let i = index
                "
              >
                <td>{{ req.consumerName }}</td>
                <td>{{ req.consumerNumber }}</td>
                <td>{{ req.consumerEmail }}</td>
                <td>{{ req.vehicleName }}</td>
                <td>{{ req.placeName }}</td>
                <td>
                  {{ (req.fromDate | date : "d/MM/y, h:mm:ss a") || "----" }}
                </td>
                <td>{{ req.toDate | date : "d/MM/y, h:mm:ss a" }}</td>
                <td>{{ req.requestStatus }}</td>
              </tr>
            </tbody>
          </table>
          <div
            *ngIf="vehicleRequests?.length == 0"
            style="
              font-size: 15px;
              font-family: inter;
              font-weight: 500;
              margin-top: 10px;
              text-align: center;
              margin-bottom: 10px;
              margin-left: 31px;
            "
          >
            No record found
          </div>
          <div style="display: flex; justify-content: center">
            <pagination-controls
              style="
                text-align: left;
                font: normal normal 300 14px/21px Poppins;
                letter-spacing: 0px;
                color: #24272a;
                opacity: 1;
              "
              previousLabel="Prev"
              nextLabel="Next"
              (pageChange)="onTableDataChange($event)"
            >
            </pagination-controls>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ngx-spinner
    bdColor="rgba(51, 51, 51, 0.8)"
    size="default"
    type="ball-spin-clockwise"
  >
    <p style="color: white">Please Wait.</p>
  </ngx-spinner>
</section>
